

































































































import { Component, Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { mixins } from "vue-class-component";
import ViewSwitchMixin from "@/mixins/ViewSwitchMixin";
import FscCard from "@/components/Card/FscCard.vue";
import Validation from "@/components/Validation.vue";
import { Validate } from "vuelidate-property-decorators";
import { required } from "vuelidate/lib/validators";
import Datepicker from "@/components/Datepicker.vue";
import TimePicker from "@/components/TimePicker.vue";
import AbortButton from "@/components/Button/AbortButton.vue";
import SaveButton from "@/components/Button/SaveButton.vue";
import { IPracticalExam } from "@/interfaces/Exam/IPracticalExam";
import ExamMixin from "@/mixins/ExamMixin";

const TestingOrganizationsModule = namespace("testing-organizations");

@Component({
  components: {
    SaveButton,
    AbortButton,
    TimePicker,
    Datepicker,
    Validation,
    FscCard,
  },
})
export default class PracticalExamForm extends mixins(ViewSwitchMixin, ExamMixin) {
  public name = "PracticalExamForm";

  private availableSlots?: number | null = null;
  @Validate({ required })
  private date?: Date | null = null;
  private listNumber: number | null = null;
  private notes?: string | null = null;
  private station?: number | null = null;
  @Validate({ required })
  private time?: Date | null = null;
  private proctor?: string | null = null;
  @Validate({ required })
  private testingOrganization?: any | null = null;

  @Prop({ default: null })
  private exam!: IPracticalExam;

  @Prop()
  private loading!: any;

  @TestingOrganizationsModule.Action("filter")
  public findAllTestingOrganizations: any;

  @TestingOrganizationsModule.Getter("getDataList")
  public allTestingOrganizations: any;

  public mounted(): void {
    this.findAllTestingOrganizations({
      resource: "testing-organizations",
      filter: { archived: false },
    });
  }

  @Watch("exam", { deep: true, immediate: true })
  private onExamChange(exam: any): void {
    if (exam) {
      this.availableSlots = exam.availableSlots;
      this.date = exam.date;
      this.listNumber = exam.listNumber;
      this.notes = exam.notes;
      this.station = exam.station;
      this.time = exam.time;
      this.proctor = exam.proctor;
      this.testingOrganization = exam.testingOrganization;
    }
  }

  public validate(): boolean {
    this.$v.$touch();
    return this.$v.$invalid;
  }

  private onSubmit(): void {
    if (this.validate()) {
      return;
    }
    const exam = {
      id: 0,
      availableSlots: this.availableSlots,
      date: this.date,
      listNumber: this.listNumber,
      notes: this.notes,
      station: this.station,
      time: this.time,
      proctor: this.proctor,
      testingOrganization: {
        id: this.testingOrganization.id,
        name: this.testingOrganization.name,
      },
    };
    if (this.exam && this.exam.id) {
      exam.id = this.exam.id;
    }
    this.$emit("on-submit", exam);
  }

  private onClose(): void {
    this.$emit("on-close");
  }

  public get isBooked() {
    return this.exam?.booked || false;
  }
}
